var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "140px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "订单编号:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.orderNo))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "项目类型:" } }, [
                    _vm.childData.businessType == 1
                      ? _c("span", [_vm._v("培训活动")])
                      : _vm._e(),
                    _vm.childData.businessType == 2
                      ? _c("span", [_vm._v("场地预定")])
                      : _vm._e(),
                    _vm.childData.businessType == 3
                      ? _c("span", [_vm._v("共享空间")])
                      : _vm._e(),
                    _vm.childData.businessType == 4
                      ? _c("span", [_vm._v("演艺票务")])
                      : _vm._e(),
                    _vm.childData.businessType == 5
                      ? _c("span", [_vm._v("游泳票务")])
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "项目名称:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.orderName))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "报名内容:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.content))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "订单总额(元):" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.orderAmount))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "订单状态:" } }, [
                    _vm.childData.status == 1
                      ? _c("span", [_vm._v("待支付")])
                      : _vm._e(),
                    _vm.childData.status == 2
                      ? _c("span", [_vm._v("已支付")])
                      : _vm._e(),
                    _vm.childData.status == 3
                      ? _c("span", [_vm._v("退款中")])
                      : _vm._e(),
                    _vm.childData.status == 4
                      ? _c("span", [_vm._v("已退款")])
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "支付交易号:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.tradeNo))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "支付方式:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.opType))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "退款时间:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.refundTime))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "订单创建时间:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.createTime))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "订单支付时间:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.paySuccessTime))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "客户微信昵称:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.openName))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "姓名:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.stuName))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "联系方式:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.stuTel))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "备注:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.remark))])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }